import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, fileUrl, FALLBACK_ARTIST } from "@/lib/api";
import { ReleaseCard } from "@/components/site/ReleaseCard";
import { PlatformLinks } from "@/components/site/PlatformLinks";
import { ShareButton } from "@/components/site/ShareButton";
import { SITE } from "@/components/site/Seo";

export default function ArtistDetail() {
  const { id } = useParams();
  const [artist, setArtist] = useState(undefined);
  const [releases, setReleases] = useState([]);
  useEffect(() => {
    api.get(`/artists/${id}`).then((r) => setArtist(r.data)).catch(() => setArtist(null));
    api.get("/releases", { params: { artist_id: id } }).then((r) => setReleases(r.data)).catch(() => {});
  }, [id]);
  useEffect(() => {
    if (!artist) return;
    document.title = `${artist.name} | The Groove Anomaly records`;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", `${SITE}/artisti/${artist.id}`);
  }, [artist]);

  if (artist === undefined) return <div className="pt-40 text-center font-mono-tga text-zinc-500">Caricamento…</div>;
  if (artist === null) return <div className="pt-40 text-center" data-testid="artist-not-found">Artista non trovato.</div>;

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-28" data-testid="artist-detail-page">
      <Link to="/artisti" className="inline-flex items-center gap-2 font-mono-tga text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white" data-testid="artist-back-link"><ArrowLeft className="h-4 w-4" /> Artisti</Link>
      <div className="grid md:grid-cols-[1fr_1.4fr] gap-12 mt-8">
        <img src={fileUrl(artist.photo_url) || FALLBACK_ARTIST} alt={artist.name} className="w-full aspect-[4/5] object-cover border border-white/10" />
        <div className="space-y-6">
          <p className="font-mono-tga text-xs uppercase tracking-[0.3em] text-emerald-400">{[artist.genre, artist.city].filter(Boolean).join(" · ")}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter" data-testid="artist-name">{artist.name}</h1>
          <p className="text-sm sm:text-base leading-relaxed text-zinc-300 whitespace-pre-line">{artist.bio}</p>
          <PlatformLinks links={artist.links} prefix="artist-platform" />
          <ShareButton sharePath={`artist/${artist.id}`} title={`${artist.name} - The Groove Anomaly records`} testid="artist-share-btn" />
        </div>
      </div>
      {releases.length > 0 && (
        <section className="mt-20">
          <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight mb-8">Discografia</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {releases.map((r, i) => <ReleaseCard key={r.id} release={r} i={i} />)}
          </div>
        </section>
      )}
    </div>
  );
}
